// alterado - revisado

export const comSemDiaDiaEstudoList = [
    {
        id: 'C',
        descricao: 'Com o Dia a Dia',
        ordem: 10,
    },
    {
        id: 'S',
        descricao: 'Sem o Dia a Dia',
        ordem: 20,
    },
]

export default comSemDiaDiaEstudoList